<template>
  <element>
    <AppBar :title="title" />
    <v-container class="pt-0">
      <v-icon class="page-icon" color="#2e384d" size=60>mdi-car-cog</v-icon>
      <p class="desc">{{ $t('selectPartGroupsPage.description') }}</p>
      <div class="scroll-area mt-3 mb-4">
        <v-treeview
          v-model="selected"
          selectable
          open-on-click
          open-all
          selected-color="#033e8c"
          :items="items"
          :expand-icon="null"
        >
        </v-treeview>
      </div>
      <v-btn
        class="submit-btn"
        height="45px"
        color="#033e8c"
        depressed
        block
        dark
        @click="complete"
        >
        {{ title }}
      </v-btn>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";

import { getTreeItems } from "@/helpers" 

export default {
  name: "SelectPartGroupsPage",
  components: {
    AppBar,
  },
  props: {

  },
  data () {
    return {
      title: '',
      carId: null,
      items: [],
      selected: null
    }
  },
  created() {
    this.title = this.$store.getters.getCurrentTask.taskName
    
    const pid = this.$store.getters.getCurrentPID
    this.$store.dispatch('retrieveProcessVariables', pid)
    .then(response => {
      try {
        this.carId = response.data.data.car_id.value
        this.update(this.carId)
      } catch (error) {
        console.log("Failed retrieving variables from API.", error)
      }
    })
    .catch(error => {
      console.log("Failed retrieving variables from API", error)
    })
    // this.update(4)
  },
  methods: {
    update(id) {
      this.axios.get(`/PartGroupsTemplate/get?car_id=${id}`, {}, { withCredentials: true })
      .then(response => {
        console.log("response data", response.data.data)
        this.items = getTreeItems(response.data.data)
      })
      .catch(error => {
        console.log("Failed retrieving part groups", error)
      })
    },
    complete() {
      console.log("Treeview selected items", this.selected)

      const variables = {
        "variables": {
          "part_group_id": {
            "value": JSON.stringify(this.selected)
          }
        }
      }

      const taskId = this.$store.getters.getCurrentTask?.id

      if (taskId) {
        this.$store.dispatch('completeTask', { taskId, variables })
        .then(response => {
          console.log("Task completed successfully!", taskId, response)
        })
        .catch(error => {
          console.log("Failed completing task!", taskId, error)
        })
      }
    }
  }
}
</script>

<style>
.scroll-area {
  height: 450px;
  overflow: auto;
}

.v-treeview-node__label {
  flex: none;
  margin-left: 5px;
}
</style>